<template>
  <div class="hm-recharge">
    <div class="hm-headline">
      <span class="headline">积分商城</span>
      <span class="subhead">兑换商品管理</span>
    </div>
    <el-card>
      {{ allRulesTotal }}
      <div class="flex flex-between panel-header">
        <div>
          <el-button
            size="small"
            @click="addExchangeGoods"
            type="primary"
            icon="hmicon icon-jiahao"
            >添加商品</el-button
          >
        </div>
        <div>
          <el-select
            size="small"
            v-model="relateStatus"
            placeholder="选择商品类型"
            clearable
          >
            <el-option label="全部" value=" "></el-option>
            <el-option label="已关联" :value="1"></el-option>
            <el-option label="未关联" :value="0"></el-option>
          </el-select>
          <el-select
            size="small"
            v-model="relateStatus"
            placeholder="选择兑换状态"
            clearable
          >
            <el-option label="全部" value=" "></el-option>
            <el-option label="已关联" :value="1"></el-option>
            <el-option label="未关联" :value="0"></el-option>
          </el-select>
          <el-input
            size="small"
            placeholder="商品名称"
            clearable
            v-model.trim="couponName"
          ></el-input>
          <el-button
            size="small"
            @click="reset"
            class="hmicon icon-zhongzhi reset"
          ></el-button>
          <el-button size="small" type="primary" @click="search"
            >查询</el-button
          >
        </div>
      </div>
      <div class="table">
        <el-table border :data="data" style="width: 100%">
          <el-table-column
            header-align="center"
            align="center"
            type="index"
              label="序号"
            width="50"
            :index="index => index + (currentPage - 1) * pageSize + 1"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="name"
            label="商品名称"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="levelMin"
            label="分类"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="account"
            label="商城售价"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="account"
            label="库存"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="discount"
            label="兑换积分"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="discount"
            label="兑换金额"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="useRank"
            label="已兑换数量"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="兑换时间"
            width="200"
          >
            <template slot-scope="scope">
              <el-button
                size="small"
                type="text"
                @click="getRuleTime(scope.row.id)"
                >{{ scope.row.validTime }}</el-button
              >
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="status"
            label="兑换状态"
          >
          </el-table-column>
          <el-table-column header-align="center" align="center" label="操作">
            <template slot-scope="scope">
              <el-button
                size="small"
                type="text"
                @click="editItem(scope.row.id, scope.row.type)"
                >编辑</el-button
              >
              <el-button
                size="small"
                type="text"
                @click="deleteItem(scope.row.id, scope.row.type)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      data: []
    };
  },
  created() {
    this.$store.dispatch("getAllRules", {
      endDate: "",
      isPlus: "",
      label: 2,
      name: "",
      pageNo: 1,
      startDate: "",
      status: 1,
      type: ""
    });
  },
  computed: {
    // allRules() {
    //   return this.$store.getters.allRules
    // }
    ...mapGetters(["allRules", "allRulesTotal"])
  },

  methods: {
    addExchangeGoods() {
      this.$router.push({
        name: "integralGoods",
        query: { type: "add", id: "null" }
      });
    },
    editItem() {
      this.$router.push({
        name: "integralGoods",
        query: { type: "add", id: "null" }
      });
    },
    deleteItem() {}
  }
};
</script>
<style lang="scss" scoped>
.table {
  padding: 10px 0;
}
</style>
